import React, { ReactElement, useRef } from 'react';
import CSS from './MenuBtn.module.scss';

interface IParentProps {
	children?: ReactElement;
	onClick?: (btnRef: React.MutableRefObject<HTMLButtonElement | null>, id: string | undefined, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => unknown;
	onPointerUp?: (e: React.PointerEvent<HTMLButtonElement>) => unknown;
	disabled?: boolean;
	style?: React.CSSProperties;
	id?: string;
	isActive?: boolean;
	classNames?: string[] | string;
	tabIndex?: number;
	testId?: string;
}

const Btn = ({ onClick, disabled, children, style = {}, id, classNames, onPointerUp, tabIndex, testId = 'Btn' }: IParentProps) => {
	const btnRef: React.MutableRefObject<HTMLButtonElement | null> = useRef(null);
	let classes = classNames || [];
	if (typeof classes === 'string') {
		classes = [classes, CSS.Btn];
	} else classes = [...classes, CSS.Btn];

	return (
		<button
			data-testid={testId}
			ref={btnRef}
			className={classes.join(' ')}
			style={{
				opacity: disabled ? '0.3' : '1',
				...style,
			}}
			disabled={disabled}
			onClick={(e) => {
				e.stopPropagation();
				onClick?.(btnRef, id, e);
			}}
			onPointerUp={(e) => {
				e.stopPropagation();
				onPointerUp?.(e);
			}}
			tabIndex={tabIndex}
		>
			{children}
		</button>
	);
};

export default Btn;
